export default __webpack_public_path__ + "static/27-853e58cd4fd2f419155da9e7baf71ef3.webp";